export default __webpack_public_path__ + "static/media/external_source.4349ee20.svg";